import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {};

const scrollTracking = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SCROLL_REQUIREMENT_MET':
      return dotProp.set(state, action.ticketId, true);
    default:
      return state;
  }
};

export default scrollTracking;
